/*
 * Halkhouse brand -> model picker.
 *
 * Products carry two options: "Marka" (brand) and "Model". The theme renders
 * both as <select>s. This script makes the Model list depend on the chosen
 * Marka: models that do not exist for that brand are hidden, and if the current
 * model disappears the first remaining one is selected so the variant stays valid.
 *
 * The theme morphs the product section after every variant change, so nothing
 * is cached on elements: every pass re-reads the DOM.
 */
(function () {
  "use strict";

  var BRAND = "Marka";
  var MODEL = "Model";

  function selectFor(picker, optionName) {
    return picker.querySelector('select[name="options[' + optionName + ']"]');
  }

  function readVariantOptions(picker) {
    var el = picker.querySelector("[data-hh-variant-options]");
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function apply(picker) {
    var brandSel = selectFor(picker, BRAND);
    var modelSel = selectFor(picker, MODEL);
    if (!brandSel || !modelSel) return;

    var variants = readVariantOptions(picker);
    if (!variants) return;

    var brand = brandSel.value;
    var allowed = {};
    variants.forEach(function (v) {
      if (v.marka === brand) allowed[v.model] = true;
    });

    var firstVisible = null;
    var currentHidden = false;
    Array.prototype.forEach.call(modelSel.options, function (opt) {
      var ok = !!allowed[opt.value];
      opt.hidden = !ok;
      opt.disabled = !ok;
      if (ok && !firstVisible) firstVisible = opt;
      if (!ok && opt.selected) currentHidden = true;
    });

    if (currentHidden && firstVisible) {
      modelSel.value = firstVisible.value;
      // Let the theme's variant picker pick up the new variant.
      modelSel.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  function applyAll(root) {
    var scope = root && root.querySelectorAll ? root : document;
    Array.prototype.forEach.call(scope.querySelectorAll("variant-picker"), apply);
  }

  document.addEventListener("change", function (e) {
    var t = e.target;
    if (!(t instanceof HTMLSelectElement)) return;
    if (t.name !== "options[" + BRAND + "]") return;
    var picker = t.closest("variant-picker");
    if (picker) apply(picker);
  });

  // Re-run after the theme morphs the section (variant change re-renders the form).
  var mo = new MutationObserver(function (records) {
    var touched = false;
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === "childList" && r.addedNodes.length) { touched = true; break; }
    }
    if (touched) applyAll(document);
  });

  function boot() {
    applyAll(document);
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
